import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [click, setClick] = useState(false);
  // Single piece of state for whichever dropdown is open: 'apropos' | 'services' | null
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => {
    setClick(false);
    setOpenDropdown(null);
  };

  const toggleDropdown = (key) =>
    setOpenDropdown((prev) => (prev === key ? null : key));

  const handleEnter = (key) => {
    if (window.innerWidth >= 960) setOpenDropdown(key);
  };
  const handleLeave = () => {
    if (window.innerWidth >= 960) setOpenDropdown(null);
  };

  return (
    <header className="header">
      <nav className="navbar">
        <div className="container navbar-container">
          <Link to="/" className="logo" onClick={closeMobileMenu}>
            ATAA <span>REALTY</span>
          </Link>

          <div className="menu-icon" onClick={handleClick}>
            {click ? <FaTimes /> : <FaBars />}
          </div>

          <ul className={click ? 'nav-menu active' : 'nav-menu'}>

            {/* À PROPOS dropdown */}
            <li
              className="nav-item"
              onMouseEnter={() => handleEnter('apropos')}
              onMouseLeave={handleLeave}
            >
              <div
                className="nav-links dropdown-trigger"
                onClick={() => toggleDropdown('apropos')}
              >
                À Propos <FaChevronDown className="arrow-icon" />
              </div>
              {openDropdown === 'apropos' && (
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/notre-histoire" className="dropdown-link" onClick={closeMobileMenu}>
                      Notre Histoire
                    </Link>
                  </li>
                  <li>
                    <Link to="/mot-directeur" className="dropdown-link" onClick={closeMobileMenu}>
                      Mot du Directeur
                    </Link>
                  </li>
                  <li>
                    <Link to="/notre-equipe" className="dropdown-link" onClick={closeMobileMenu}>
                      Notre Équipe
                    </Link>
                  </li>
                  <li>
                    <Link to="/nos-standards" className="dropdown-link" onClick={closeMobileMenu}>
                      Nos Standards
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* SERVICES dropdown */}
            <li
              className="nav-item"
              onMouseEnter={() => handleEnter('services')}
              onMouseLeave={handleLeave}
            >
              <div
                className="nav-links dropdown-trigger"
                onClick={() => toggleDropdown('services')}
              >
                Services <FaChevronDown className="arrow-icon" />
              </div>
              {openDropdown === 'services' && (
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      to="/services"
                      className="dropdown-link dropdown-link-overview"
                      onClick={closeMobileMenu}
                    >
                      Vue d'ensemble
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/expertise" className="dropdown-link" onClick={closeMobileMenu}>
                      Expertise
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/conseil" className="dropdown-link" onClick={closeMobileMenu}>
                      Conseil
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/etudes" className="dropdown-link" onClick={closeMobileMenu}>
                      Études
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/formation" className="dropdown-link" onClick={closeMobileMenu}>
                      Formation
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li className="nav-item">
              <Link to="/blog" className="nav-links" onClick={closeMobileMenu}>Blogs</Link>
            </li>

            <li className="nav-item">
              <Link to="/actualites" className="nav-links" onClick={closeMobileMenu}>Actualités</Link>
            </li>

            <li className="nav-item">
              <Link to="/bibliotheque" className="nav-links" onClick={closeMobileMenu}>Bibliothèque</Link>
            </li>

            <li className="nav-item">
              <Link to="/contact" className="nav-links" onClick={closeMobileMenu}>Contact</Link>
            </li>
          </ul>

         
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
